var _rect, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrTurkey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 32,
    viewBox: "0 0 43 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_356_1314",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 4,
    width: 32,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4,
    width: 32,
    height: 24,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_356_1314)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4V28H37V4H5Z",
    fill: "#E31D1C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_356_1314",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 4,
    width: 32,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4V28H37V4H5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_356_1314)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0255 20.1135C18.8841 19.586 17.207 17.7937 17.2265 15.1663C17.2447 12.7069 18.7338 10.6281 21.0877 10.0653C23.4417 9.50254 25.5141 10.6972 25.5141 10.6972C24.8635 9.16134 22.6033 8.08239 20.7503 8.08549C17.3011 8.09127 13.6242 10.8885 13.5925 15.1663C13.5597 19.6013 17.5299 22.1271 21.0217 22.1212C23.821 22.1165 25.1488 20.2014 25.4238 19.3867C25.4238 19.3867 23.1668 20.641 21.0255 20.1135ZM25.9033 14.3266L23.7699 15.1102L26.1771 15.9594L26.136 18.4968L27.7222 16.5932L30.3423 16.7836L28.266 14.9989L29.6291 13.0951L27.4096 13.842L25.8232 12.0784L25.9033 14.3266Z",
    fill: "#F7FCFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrTurkey);
export default __webpack_public_path__ + "static/media/TR - Turkey.864a5c53c401261ffdd8aa192b3bedf1.svg";
export { ForwardRef as ReactComponent };